import {FETCH_SOCIAL_REQUEST, FETCH_SOCIAL_SUCCES, FETCH_SOCIAL_ERROR} from '../constants/Social'

const initialState = {
  item: {},
  hasErrored: false,
  isLoading: false
}

export default function social(state = initialState, action) {
  switch (action.type) {
      case FETCH_SOCIAL_REQUEST:
        return {...state, isLoading: true};
      case FETCH_SOCIAL_SUCCES:
        return {...state, item: action.payload, isLoading: false};
      case FETCH_SOCIAL_ERROR:
        return {...state, hasErrored: true, isLoading: false};
      default:
          return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/social.js